import { useTranslation } from 'react-i18next'

import X from '@/presentation/assets/svg/X.svg'

interface KnowMoreModalProps {
  onCancel: () => void
}

const KnowMoreModal: React.FC<KnowMoreModalProps> = ({ onCancel }) => {
  const { t } = useTranslation()

  const handleClose = () => onCancel()

  return (
    <div
      onClick={handleClose}
      className="fixed inset-0 flex items-center justify-center bg-[#70707059] px-4"
    >
      <div
        className="flex max-w-[460px] flex-col rounded-lg bg-white p-4 px-6"
        onClick={event => event.stopPropagation()}
      >
        <div className="mb-1 flex items-center justify-between">
          <span className="text-lg text-gray-700">
            {t('CONTESTATION_MENU', 'Contestação')}
          </span>

          <img src={X} onClick={handleClose} className="cursor-pointer" />
        </div>

        <hr className="mb-4" />

        <span className="mb-1 text-gray-700">
          <span className="font-bold text-primary">
            {t(
              'CONTESTATIONS_ARE_USED_TO_POINT_OUT_DIFFERENCES',
              'Contestações são utilizadas para apontar as diferenças'
            )}
          </span>{' '}
          {t(
            'BETWEEN_INSPECTION_AND_CURRENT_STATE',
            'entre a vistoria e o estado presente do imóvel.'
          )}
          <br />
          <span className="font-bold text-primary">
            {t(
              'IF_ANY_DETAIL_NOT_IN_YOUR_REPORT',
              'Caso seja detectado algum detalhe que não conste em seu relatório'
            )}
          </span>
          ,{' '}
          {t(
            'USE_CONTESTATION_OPTION',
            'utilize a opção de Contestação nas dependências e itens da vistoria.'
          )}
        </span>
      </div>
    </div>
  )
}

export default KnowMoreModal
